import types from '../actions/types';
import {paginatedResultReducer, initialState} from './common/paginated_results';
import {singleResultReducer, singleResultInitialState} from './common/single-result';

const initial_state = {
    page: singleResultInitialState,
    pages: initialState
}

export default function(state = initial_state, action) {
    switch (action.type) {
        case types.DELETE_PAGE.SUCCESS:

            return {
                ...state,
                pages: {
                    ...state.pages,
                    items: removePage(state.pages.items, action.payload.id)
                }

            }

        default:
            return {
                ...state,
                pages: paginatedResultReducer(state.pages, types.LOAD_PAGES_PAGINATED, action),
                page: singleResultReducer(state.page, types.LOAD_PAGE, action)

            };
    }
}
function removePage(pages, pageToRemoveId) {
    let pagesReturn = [];
    pages.forEach(page => {
        if (page.id !== pageToRemoveId) {
            pagesReturn.push(page);
        }
    });
    return pagesReturn;
}



// WEBPACK FOOTER //
// ./src/js/reducers/page.js